import React from 'react';
import { FormattedNumber } from 'react-intl';


const GIC_BALANCE = [ 1_000, 5_000, 10_000, 50_000, 100_000 ];

const GIC_BALANCE_OPTIONS = GIC_BALANCE.map(value => ({
    value: value,
    label: (
        <FormattedNumber
            value={value}
            format="CAD0"
            minimumFractionDigits={0}
            maximumFractionDigits={0}
        />
    ),
}));


export { GIC_BALANCE };
export default GIC_BALANCE_OPTIONS;
